<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8 5.30921C8.52211 5.30921 8.94538 4.88593 8.94538 4.36377C8.94538 3.84161 8.52211 3.41833 8 3.41833C7.47782 3.41833 7.05455 3.84161 7.05455 4.36377C7.05455 4.88593 7.47782 5.30921 8 5.30921ZM8 6.54545C8.40167 6.54545 8.72727 6.87105 8.72727 7.27273V11.2727C8.72727 11.6744 8.40167 12 8 12C7.59833 12 7.27273 11.6744 7.27273 11.2727V7.27273C7.27273 6.87105 7.59833 6.54545 8 6.54545Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
